import { useRestaurantStore } from '~/store'

export function useOrderConfigConfirmationModal() {
  const isOrderConfigConfirmationModalOpen = ref(false)
  const isOrderConfigConfirmationModalSuppressed = ref(false)

  /**
   * @description Check whether the order config confirmation modal should be shown
   * @param {string} routePath - The current route path
   */
  function performOrderConfigConfirmationCheck(routePath: string) {
    const restaurantStore = useRestaurantStore()

    if (
      !isOrderConfigConfirmationModalOpen.value &&
      !isOrderConfigConfirmationModalSuppressed.value &&
      restaurantStore.getWillShowOrderConfigConfirmation &&
      routePath === '/home'
    ) {
      isOrderConfigConfirmationModalOpen.value = true
    }
  }

  return {
    isOrderConfigConfirmationModalOpen,
    isOrderConfigConfirmationModalSuppressed,
    performOrderConfigConfirmationCheck
  }
}
